import { useEffect, useRef } from 'react';
import type { ChatComposerDictation } from './chat-composer-types.ts';

/**
 * Escape throws the recording away, the way it dismisses everything else on
 * the page. On the document rather than on the form: a recording takes the
 * whole composer over, and there is nothing left in it to hold the caret.
 */
export function useEscapeCancelsRecording(listening: ChatComposerDictation | null) {
  /* Read from a listener that outlives the render that set it up. */
  const latest = useRef(listening);
  const recording = listening?.state === 'recording';

  useEffect(() => {
    latest.current = listening;
  });

  /* Not while the words are on their way to the server: nothing may be pressed then. */
  useEffect(() => {
    if (!recording) {
      return;
    }

    function onEscape(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        latest.current?.onCancel();
      }
    }

    document.addEventListener('keydown', onEscape);

    return () => document.removeEventListener('keydown', onEscape);
  }, [recording]);
}
